import React from "react";

import placeholder from '../../../assets/images/placeholder.png';
import bigOne from '../../../assets/images/big1.svg';
import bigTwo from '../../../assets/images/big2.svg';
import bigThree from '../../../assets/images/big3.svg';
import vip from '../../../assets/images/live-vip.jpg';

const Mint = () => {
  return (
      <section className="mint">
        <div className="container mx-auto">
            <img className="justify-center mx-auto banner" src={vip} alt="mint a metafans"></img>
            <h1 className="lt-white font-bold text-center mt-5">Mint a MetaFan NFT and Live Like a VIP</h1>
            <div className="flex mt-5 mint-list">
                <div className="flex p-3">
                    <div>
                        <img src={bigOne} alt="steps to minting a metafan"></img>
                    </div>
                    <p className="text-grey"><span className="font-bold">Join the ultimate sports community where everyone is a VIP!</span> A community of diverse sports lovers, over 11K strong, MetaFans holders get exclusive access to the best online experiences possible!</p>
                </div>
                <div className="flex p-3">
                    <div>
                        <img src={bigTwo} alt="steps to minting a metafan"></img>
                    </div>
                    <p className="text-grey"><span className="font-bold">Experience the VIP treatment at sporting events and concerts!</span> We give away tickets in our community every week. Enjoy your favorite sporting events from the best seats in the house!</p>
                </div>
                <div className="flex p-3">
                    <div>
                        <img src={bigThree} alt="steps to minting a metafan"></img>
                    </div>
                    <p className="text-grey"><span className="font-bold">Party like a VIP!</span> Holders have exclusive access to MetaFans VIP Gatherings. Hosted at venues across the nation, these epic gatherings allow MetaFans NFT holders to congregate IRL and enjoy VIP-level parties.</p>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Mint;